import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { ReactNode } from "react";

interface LoadingContainerProps {
	isLoading: boolean;
	children: ReactNode;
	fontSize?: number;
}

export const LoadingContainer: React.FC<LoadingContainerProps> = ({ isLoading, children, fontSize = 18, }) => {
	const loadingIcon = (
		<LoadingOutlined
			style={{ fontSize, color: "#3d935e" }}
			spin
		/>
	);

	return isLoading ? <Spin indicator={loadingIcon} /> : <>{children}</>;
};